import {
  OrderItem,
  OrderPaymentMethodTypesEnum,
  OrderPaymentMethodsEnum,
  OrderVoucherDetails,
} from "@/interfaces/domain/Order";
import { Store } from "@/interfaces/domain/Store";
import { Voucher } from "@/interfaces/domain/Voucher";

export type FallbackContact = {
  name: string;
  phone: string;
  description?: string;
};

export type PaymentMethod = {
  id: string;
  method: OrderPaymentMethodsEnum;
  type: OrderPaymentMethodTypesEnum;
  description: string;
  isMoneyPayment?: boolean;
  clientMoney?: number;
  clientChange?: number;
};

export type VoucherDatails = {
  voucher: Voucher;
  initialShipmentValue: number;
  initialSubtotal: number;
  initialTotal: number;
  restrictedDays?: {
    day: number;
    restrictedHours?: number[];
  }[];
};

export type ModalPropos<T> = {
  isOpen: boolean;
  currentValue?: T;
  onClose: () => void;
  onSubmit: (data: T) => void;
};

export enum ModalTypesEnum {
  SCHEDULE,
  CONTACT,
  VOUCHER,
  PAYMENT_METHOD,
  CLIENT_DOC,
}

export type DeliveryTimeResult = {
  date?: Date;
  isExpressDelivery?: boolean;
  expressDeliveryTime?: number;
  initialHour?: number;
  finalHour?: number;
};

export type CheckoutScreenProps = {
  isLoading: boolean;
  isDisabled: boolean;
  store: Store;
  items: OrderItem[];
  total: number;
  subtotal: number;
  shipmentValue: number;
  serviceTaxValue?: number;
  fallbackContact?: FallbackContact;
  deliveryTime?: DeliveryTimeResult;
  paymentMethod?: PaymentMethod;
  clientDocument?: string;
  voucherDetails?: OrderVoucherDetails;
  onOpenModal: (type: ModalTypesEnum) => void;
  onFinishCheckout: () => void;
  onPressBack: () => void;
};
